import { TaskRow, type TaskRowItem } from "./TaskRow.js";
import { fireCommand, updateCheckItem, deleteCheckItem } from "../../api/commands.js";
import { LoadingRows } from "../ui/LoadingPlaceholders.js";
import { EmptyState, ErrorState, useT } from "@mmm/ui";
interface TaskListProps {
  items: TaskRowItem[];
  showSubjectTag?: boolean;
  allowDelete?: boolean;
  loading?: boolean;
  /** Set once the tasks query has exhausted retries — renders an ErrorState
   * with Retry instead of the list. Leave unset while a retry is in flight. */
  hasError?: boolean;
  onRetry?: () => void;
  viewMode?: "grid" | "list";
}

export function TaskList({
  items,
  showSubjectTag = false,
  allowDelete = false,
  loading = false,
  hasError = false,
  onRetry,
  viewMode = "list",
}: TaskListProps) {
  const t = useT();

  if (hasError) {
    return <ErrorState variant="list" title={t("tasks.loadFailed")} onRetry={onRetry} />;
  }

  if (loading) {
    return <LoadingRows rows={3} />;
  }

  if (items.length === 0) {
    return <EmptyState variant="list" title={t("tasks.emptyTitle")} message={t("tasks.emptyMessage")} />;
  }

  return (
    <div className={`mmm-task-list mmm-task-list--${viewMode}`}>
      {items.map((item) => (
        <TaskRow
          key={item.id}
          item={item}
          variant={viewMode}
          showSubjectTag={showSubjectTag}
          onToggle={(done) => fireCommand(updateCheckItem({ checkItemId: item.id, done }))}
          onRename={(text) => updateCheckItem({ checkItemId: item.id, text })}
          onDelete={allowDelete ? () => fireCommand(deleteCheckItem({ checkItemId: item.id })) : undefined}
        />
      ))}
    </div>
  );
}
